import loadable from "@loadable/component";
import React, { Component, PropsWithChildren, ReactNode } from "react";
import { connect } from "react-redux";
import { Action } from "redux";

import { addNotification } from "ducks/notifications/notifications";
import { RootState } from "ducks/reducers";
import { withLocation } from "hoc/withLocation";
import { MODULE_FALLBACKS } from "modules/Fallbacks";
import { MODULES_PATH } from "appConfig/modulesPath";
import { ModuleConfig, ModuleName } from "../appConfig/types";

type ModuleParams = {
  name: string;
};

type ModuleProps = {
  onError?: (error: Error, module: ModuleParams & { modulePath: string }) => void;
  render?: boolean;
} & ModuleParams;

type CreateModule = {
  path?: string;
  fallback?: ReactNode;
};

const lazyModule = ({ path }: CreateModule) =>
  loadable(() => import(`../modules/${path}.module`), { fallback: MODULE_FALLBACKS[path] });

export const preloadModule = (params: CreateModule) => {
  const module = lazyModule(params);

  module.preload();

  return module;
};

const PRELOAD_MODULES = [
  ModuleName.FeatureCard,
  ModuleName.Style,
  ModuleName.StyleEditor,
  ModuleName.Dashboard,
  ModuleName.LayerConfiguration,
  ModuleName.ProjectConfiguration,
  ModuleName.ConfigurationsTable,
  ModuleName.SymbolLibrary,
  ModuleName.Catalog,
  ModuleName.Table,
];

export class ModuleBase extends Component<ModuleProps> {
  static defaultProps = {
    render: true,
  };

  state = {
    Page: null,
  };

  componentDidMount() {
    const { name } = this.props;
    const path = MODULES_PATH[name];

    const Page = PRELOAD_MODULES.includes(name as ModuleName) ? preloadModule({ path }) : lazyModule({ path });

    this.setState({ Page });
  }

  componentDidCatch(error) {
    const { name, onError } = this.props;
    const modulePath = MODULES_PATH[name];

    onError(error, { name, modulePath });
  }

  render() {
    const { Page } = this.state;
    const { name, onError, render, ...rest } = this.props;

    return Page && render ? <Page {...rest} /> : null;
  }
}

export const Module = connect<
  void,
  { onError: (error: Error, module: ModuleParams) => Action },
  PropsWithChildren<ModuleConfig>,
  RootState
>(null, {
  onError: (error, module) => {
    // TODO: localize it
    return addNotification({ title: `Критическая ошибка: ${module.name}`, error: true, description: error.message });
  },
})(ModuleBase);

export const RoutedModule = withLocation(Module);
